import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment'

const styles = StyleSheet.create({
    titleContainer:{
        flexDirection: 'row',
        marginTop: 18,
        justifyContent: 'space-between'
    },
    reportTitle:{
        marginTop:-16,
        fontSize: 32,
        textAlign: 'left'
    },
    info:{
        fontFamily:'HelveticaBold'
    },
    paragraph:{
        textAlign:'right',
        fontSize: 8,
    }
  });


  const InvoicePaymentInfo = ({title,invoiceNumber,period,issueDate,dueDate}) => (
    <View style={styles.titleContainer}>
        <View style={{width: '80%',flexDirection:'column'}}>
            <Text style={styles.info}>Informasi Pembayaran</Text>
            <View style={{flexDirection:'row'}}>
                <Text style={{width:'25%'}}>Bank</Text>
                <Text style={{width:'8%'}}>:</Text>
                <Text style={{width:'50%'}}>PT Bank Central Asia Tbk</Text>
            </View>
            <View style={{flexDirection:'row'}}>
                <Text style={{width:'25%'}}>Nomor Rekening</Text>
                <Text style={{width:'8%'}}>:</Text>
                <Text style={{width:'50%'}}>5425210618</Text>
            </View>
            <View style={{flexDirection:'row'}}>
                <Text style={{width:'25%'}}>Nama Rekening</Text>
                <Text style={{width:'8%'}}>:</Text>
                <Text style={{width:'50%'}}>PT Berbagi Inovasi Teknologi</Text>
            </View>
        </View>
    </View>
  );
  
  export default InvoicePaymentInfo